import { Skeleton } from '@/components/Skeleton';

import styles from './skeleton.module.scss';

const LayoutFooterSkeleton = () => (
  <div className={styles.root}>
    <Skeleton containerClassName={styles.logo} inline />
    <div className={styles.content}>
      <Skeleton className={styles.item} containerClassName={`${styles.column} _head`} count={8} inline />
      <Skeleton className={styles.item} containerClassName={`${styles.column} _headless`} count={6} inline />
      <Skeleton className={styles.item} containerClassName={`${styles.column} _head`} count={11} inline />
      <Skeleton className={styles.item} containerClassName={`${styles.column} _head _last`} count={3} inline />
    </div>
  </div>
);

export default LayoutFooterSkeleton;
